/**
 * Shared helpers for payment/report download filenames:
 * report name + selected batch/reporting date (YYYY-MM-DD), not download date.
 */
export const reportFileNameUtilities = {
    formatReportingDate(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    },

    parseReportingDate(value) {
        if (!value) {
            return null;
        }
        const raw = String(value).trim();

        // "YYYY-MM-DD" or "YYYY-MM-DD - Payment Pending"
        const isoMatch = raw.match(/^(\d{4}-\d{2}-\d{2})/);
        if (isoMatch) {
            const [y, m, d] = isoMatch[1].split('-').map(Number);
            return new Date(y, m - 1, d);
        }

        // "Jul 29 2026 09:52 AM - Batch", "Jun 30 2023  2:12PM",
        // "Jul 2026 - First time Payments"
        const cleaned = raw
            .replace(/\s+-\s+(Batch|Dry Run|Payment Pending|First time Payments).*$/i, '')
            .replace(/\s+/g, ' ')
            .replace(/\s*([AP]M)$/i, ' $1')
            .trim();
        const parsed = Date.parse(cleaned);
        if (!isNaN(parsed)) {
            return new Date(parsed);
        }
        return null;
    },

    getReportingDateFromBatch(batch) {
        if (!batch) {
            return this.formatReportingDate(new Date());
        }

        const fromBatchDate = this.parseReportingDate(batch.batchDate);
        if (fromBatchDate) {
            return this.formatReportingDate(fromBatchDate);
        }

        const fromCreatedAt = this.parseReportingDate(batch.createdAt);
        if (fromCreatedAt) {
            return this.formatReportingDate(fromCreatedAt);
        }

        if (batch.month && batch.year) {
            return `${batch.year}-${String(batch.month).padStart(2, '0')}-01`;
        }

        return this.formatReportingDate(new Date());
    },

    buildFileName(reportName, batchOrDate, extension = 'csv') {
        const date = typeof batchOrDate === 'string'
            ? batchOrDate
            : this.getReportingDateFromBatch(batchOrDate);
        return `${reportName}-${date}.${extension}`;
    }
};
